import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  getCurrentSessionHomeRoute,
  getCurrentSessionRoleLabel,
} from '../utils/companyOwner';
import '../styles/register.css';

const AccessDeniedPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const area = searchParams.get('area') || 'this area';
  const homeRoute = getCurrentSessionHomeRoute();
  const roleLabel = getCurrentSessionRoleLabel();

  return (
    <section className="register-page">
      <div className="register-shell register-shell-single">
        <div className="register-panel register-panel-form">
          <div className="register-flow-panel">
            <div className="register-status-badge">Access Denied</div>
            <h1 className="register-form-title">You do not have access to the {area} area.</h1>
            <p className="register-form-copy">
              {roleLabel
                ? `You are currently signed in as a ${roleLabel}, so this page is not available to your account.`
                : 'This page is restricted. Please sign in with an account that has access.'}
            </p>

            <div className="register-flow-actions">
              {homeRoute ? (
                <Link className="register-submit register-submit-inline" to={homeRoute}>
                  Go to my page
                </Link>
              ) : (
                <Link className="register-submit register-submit-inline" to="/login">
                  Go to login
                </Link>
              )}
              <Link className="register-secondary-button" to="/">
                Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessDeniedPage;
